import "./style/index.scss";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setIdEmpresaPermissao, setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { Col, Form, Row, Select, Image, DatePicker, DatePickerProps, Button, Tooltip, Tag, Modal, Drawer, Flex, Typography } from "antd";
import { ColumnsType } from "antd/lib/table";
import { buscarEmpresa } from "../../../../services/empresaService";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import * as Icon from "@ant-design/icons";
import { buscarAuditoriaContaFinanceira, cadastrarAuditoriaContaFinanceira } from "../../../../services/auditoriaContaFinanceiraService";
import { AuditoriaContaFinanceiraVWModel } from "../../../../models/auditoriaContaFinanceira/auditoriaContaFinanceiraVWModel";
import { AuditoriaContaFinanceiraJsonModel } from "../../../../models/auditoriaContaFinanceira/auditoriaContaFinanceiraJsonModel";
import { AuditoriaContaFinanceiraDTOModel } from "../../../../models/auditoriaContaFinanceira/auditoriaContaFinanceiraDTOModel";
import * as PhosphorIcon from "phosphor-react";
import ObservacaoAuditoriaModal from "../../modals/observacao";
import HistoricoAuditoriaModal from "../../modals/historico";
import VisualizarArquivosAuditoria from "../../modals/arquivos";
import FiltroComponent from "../../../../components/filtroComponent/filtroComponent";
import { buscarContaBanco } from "../../../../services/contaBancoService";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import {
  setBuscaAuditoriaContaFinanceira,
  setEntityAuditoriaContaFinanceira,
  setListaSelecionadaAuditoriaContaFinanceira,
  setModalHistoricoAuditoriaContaFinanceira,
  setModalObservacaoAuditoriaContaFinanceira,
  setPageAuditoriaContaFinanceira,
} from "../../../../redux/slices/auditoriaContaFinanceira/auditoriaContaFinanceiraSlice";
import { BuscaAuditoriaContaFinanceiraModel } from "../../../../models/auditoriaContaFinanceira/buscaAuditoriaContaFinanceiraModel";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../../../components/table/acoesComponent";
import TableComponent from "../../../../components/table/tableComponent";
import { Filtro } from "../../../../components/filtroComponent/filtro";
import { verificarPermissaoEmpresa } from "../../../../util/functions/verificarPermissaoEmpresa";
import { SelectedRowKeysModel } from "../../../../models/sistema/selectedRowKeysModel";

dayjs.locale("pt-br");

const GeralPage = () => {
  //estados globais
  const auditoriaState = useAppSelector((state) => state.auditoriaContaFinanceira);
  const empresaState = useAppSelector((state) => state.empresa);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [openFiltros, setOpenFiltros] = useState<boolean>(false);
  const [openVisualizarArquivos, setOpenVisualizarArquivos] = useState<boolean>(false);
  const [idEmpresaAtual, setIdEmpresaAtual] = useState<number | null>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<SelectedRowKeysModel>({ keys: [], rows: [] } as SelectedRowKeysModel);

  const editar = Object.values(auditoriaState.entity).length > 0 ? true : false;

  useEffect(() => {
    dispatch(setTitle("AUDITORIA DE CONTAS FINANCEIRAS"));
    dispatch(buscarEmpresa(empresaState.busca));
    dispatch(buscarAuditoriaContaFinanceira(auditoriaState.busca));
    if (persistedState.user.empresa !== null) {
      setIdEmpresaAtual(persistedState.user.empresa.idEmpresa);
      var busca = { ...auditoriaState.busca };
      busca.idEmpresa = persistedState.user.empresa.idEmpresa;
      dispatch(buscarAuditoriaContaFinanceira(busca));
      dispatch(setBuscaAuditoriaContaFinanceira(busca));
      form.setFieldsValue({ empresa: persistedState.user.empresa?.idEmpresa, dataInicio: dayjs(auditoriaState.busca.dataInicio), dataFim: dayjs(auditoriaState.busca.dataFim), filtroPor: "VENCI" });
    } else {
      form.setFieldsValue({ empresa: auditoriaState.busca.idEmpresa, dataInicio: dayjs(auditoriaState.busca.dataInicio), dataFim: dayjs(auditoriaState.busca.dataFim), filtroPor: "VENCI" });
    }
  }, []);

  const goEditarObservacao = (value: AuditoriaContaFinanceiraVWModel) => {
    dispatch(setEntityAuditoriaContaFinanceira(value));
    dispatch(setModalObservacaoAuditoriaContaFinanceira(true));
  };

  const closeModalObservacao = () => {
    dispatch(setModalObservacaoAuditoriaContaFinanceira(false));
  };

  const goVisualizar = (value: AuditoriaContaFinanceiraVWModel) => {
    dispatch(setEntityAuditoriaContaFinanceira(value));
    dispatch(setPageAuditoriaContaFinanceira("visualizacao"));
  };

  const goHistorico = (value: AuditoriaContaFinanceiraVWModel) => {
    dispatch(setEntityAuditoriaContaFinanceira(value));
    dispatch(setModalHistoricoAuditoriaContaFinanceira(true));
  };

  const closeModalHistorico = () => {
    dispatch(setModalHistoricoAuditoriaContaFinanceira(false));
  };

  const goVisualizarArquivos = (value: AuditoriaContaFinanceiraVWModel) => {
    dispatch(setEntityAuditoriaContaFinanceira(value));
    setOpenVisualizarArquivos(true);
  };

  const closeVisualizarArquivos = () => {
    setOpenVisualizarArquivos(false);
  };

  const aprovar = () => {
    let aprovarAuditoriaJson: AuditoriaContaFinanceiraJsonModel[] = [];

    selectedRowKeys.rows.forEach((v: AuditoriaContaFinanceiraVWModel) => {
      var detalhes = {
        idContaFinanceira: v.id,
        codigoStatusAuditoria: "APR",
        observacao: null,
        usuario: null,
      };
      aprovarAuditoriaJson.push(detalhes);
    });

    let enviar: AuditoriaContaFinanceiraDTOModel = { auditoria: aprovarAuditoriaJson } as AuditoriaContaFinanceiraDTOModel;

    dispatch(cadastrarAuditoriaContaFinanceira({ value: enviar, busca: auditoriaState.busca }));
  };

  const rejeitar = () => {
    let value = selectedRowKeys.rows[0];
    dispatch(setEntityAuditoriaContaFinanceira({ ...value }));
    dispatch(setListaSelecionadaAuditoriaContaFinanceira([...selectedRowKeys.rows[0]]));
    dispatch(setModalObservacaoAuditoriaContaFinanceira(true));
  };

  const pendente = () => {
    let pendenteAuditoriaJson: AuditoriaContaFinanceiraJsonModel[] = [];

    selectedRowKeys.rows.forEach((v: any) => {
      var detalhes = {
        idContaFinanceira: v.id,
        codigoStatusAuditoria: "PEN",
        observacao: null,
        usuario: null,
      };
      pendenteAuditoriaJson.push(detalhes);
    });

    let enviar: AuditoriaContaFinanceiraDTOModel = { auditoria: pendenteAuditoriaJson } as AuditoriaContaFinanceiraDTOModel;

    dispatch(cadastrarAuditoriaContaFinanceira({ value: enviar, busca: auditoriaState.busca }));
  };

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    setIdEmpresaAtual(value);

    let busca: BuscaAuditoriaContaFinanceiraModel = { ...auditoriaState.busca, idEmpresa: value };

    dispatch(setBuscaAuditoriaContaFinanceira(busca));
    dispatch(buscarAuditoriaContaFinanceira(busca));
    dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: value }));
  };

  const onChangeDateInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscaAuditoriaContaFinanceiraModel = { ...auditoriaState.busca, dataInicio: dayjs(value).toDate() };

    dispatch(setBuscaAuditoriaContaFinanceira(busca));
    dispatch(buscarAuditoriaContaFinanceira(busca));
  };

  const onChangeDateFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscaAuditoriaContaFinanceiraModel = { ...auditoriaState.busca, dataFim: dayjs(value).toDate() };

    dispatch(setBuscaAuditoriaContaFinanceira(busca));
    dispatch(buscarAuditoriaContaFinanceira(busca));
  };

  const onChangeTipo = (value: string) => {
    let busca: BuscaAuditoriaContaFinanceiraModel = { ...auditoriaState.busca, tipoFiltroData: value };

    dispatch(setBuscaAuditoriaContaFinanceira(busca));
    dispatch(buscarAuditoriaContaFinanceira(busca));
  };

  const selecionarLinha = (value: SelectedRowKeysModel) => {
    setSelectedRowKeys(value);
  };

  const atualizar = () => {
    dispatch(buscarAuditoriaContaFinanceira(auditoriaState.busca));
  };

  //componente de filtro
  const onChangeMostrarFiltros = async () => {
    try {
      await form.validateFields();
      setOpenFiltros(!openFiltros);
    } catch (e) {}
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar observação",
      key: "1",
      icon: <PhosphorIcon.Pencil size={16} color="#212937" weight="light" />,
      function: (item: any) => goEditarObservacao(item),
    },
    {
      label: "Ver histórico",
      key: "2",
      icon: <PhosphorIcon.ChartLine size={16} color="#212937" weight="light" />,
      function: (item: any) => goHistorico(item),
    },
  ];

  const columns: ColumnsType<AuditoriaContaFinanceiraVWModel> = [
    {
      title: "STATUS",
      dataIndex: "denominacaoStatus",
      filters: [
        {
          text: "Aprovado",
          value: "Aprovado" as any,
        },
        {
          text: "Rejeitado",
          value: "Rejeitado" as any,
        },
        {
          text: "Pendente",
          value: "Pendente" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.denominacaoStatus.toString().includes(value),
      defaultFilteredValue: ["Pendente" as any],
      render: (_, record) => <Tag key={record.denominacaoStatus}>{record.denominacaoStatus}</Tag>,
    },
    {
      title: "OBSERVAÇÃO",
      dataIndex: "observacao",
      align: "center",
      render: (_, record) =>
        record.observacao && (
          <Tooltip placement="top" title={record.observacao}>
            <Button size="small">
              <Icon.FileTextOutlined />
            </Button>
          </Tooltip>
        ),
    },
    {
      title: "DOC.",
      dataIndex: "numeroDocumento",
    },
    {
      title: "FORNECEDOR",
      dataIndex: "apelidoPessoa",
      width: 200,
      sorter: (a, b) => a.apelidoPessoa.localeCompare(b.apelidoPessoa),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (
        <Typography.Text style={{ width: 250 }} ellipsis={{ tooltip: record.apelidoPessoa }}>
          {record.apelidoPessoa}
        </Typography.Text>
      ),
    },
    {
      title: "EMISSÃO",
      dataIndex: "dataEmissao",
      render: (_, record) => <>{dayjs(record.dataEmissao).format("DD/MM/YYYY")}</>,
    },
    {
      title: "VENCIMENTO",
      dataIndex: "dataVencimento",
      render: (_, record) => <>{dayjs(record.dataVencimento).format("DD/MM/YYYY")}</>,
    },
    {
      title: "VALOR",
      dataIndex: "valorBruto",
      align: "right",
      sorter: (a: any, b: any) => a.valorBruto - b.valorBruto,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorBruto),
    },
    {
      title: "VALOR PAGO",
      dataIndex: "valorPago",
      align: "right",
      sorter: (a: any, b: any) => a.valorPago - b.valorPago,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorPago),
    },
    {
      title: "HISTÓRICO",
      dataIndex: "historico",
      align: "center",
      sorter: (a, b) => a.historico.localeCompare(b.historico),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) =>
        record.historico && (
          <Tooltip placement="top" title={record.historico}>
            <Button size="small">
              <Icon.FileTextOutlined />
            </Button>
          </Tooltip>
        ),
    },
    {
      title: "ANEXOS",
      dataIndex: "temAnexo",
      align: "center",
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => (
        <>
          {record.temAnexo && (
            <Button size="small" onClick={() => goVisualizarArquivos(record)}>
              <Icon.PaperClipOutlined />
            </Button>
          )}
        </>
      ),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Filtro abrir={openFiltros} funcao={onChangeMostrarFiltros} />
      {openFiltros && <FiltroComponent idEmpresa={idEmpresaAtual} origem={"auditoria"} />}
      <Form layout="vertical" form={form} style={openFiltros ? { marginTop: "0px" } : { marginTop: "14px" }}>
        <Row gutter={12} align="bottom">
          <Col span={17}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresa"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Selecione uma empresa",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Filtrar por" name="filtroPor">
                <Select
                  defaultValue={"VENCI"}
                  onChange={onChangeTipo}
                  style={{ width: 150 }}
                  placeholder="Selecione uma opção"
                  className="selectTipoAuditoria"
                  options={[
                    { value: "EMISS", label: "Emissão" },
                    { value: "VENCI", label: "Vencimento" },
                    { value: "COMPE", label: "Competência" },
                    { value: "PAGAM", label: "Pagamento" },
                  ]}
                />
              </Form.Item>
              <Form.Item label="Data início" name="dataInicio">
                <DatePicker placeholder="" allowClear={false} onChange={onChangeDateInicio} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data fim" name="dataFim">
                <DatePicker placeholder="" allowClear={false} onChange={onChangeDateFim} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<Icon.RedoOutlined />} className="buttonPrimary" style={{ minHeight: 32 }} onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={7}>
            <Flex justify="end" gap={12}>
              {verificarPermissaoEmpresa() && (
                <>
                  <Form.Item label=" ">
                    <Tooltip title="Selecione uma conta">
                      <Button icon={<Icon.CheckSquareOutlined className="buttonAprovar" />} className="buttonAprovar" onClick={aprovar} disabled={selectedRowKeys.rows.length === 0}>
                        APROVAR
                      </Button>
                    </Tooltip>
                  </Form.Item>
                  <Form.Item label=" ">
                    <Tooltip title="Selecione uma conta">
                      <Button icon={<Icon.StopOutlined className="buttonRejeitar" />} className="buttonRejeitar" onClick={rejeitar} disabled={selectedRowKeys.rows.length === 0}>
                        REJEITAR
                      </Button>
                    </Tooltip>
                  </Form.Item>
                  <Form.Item label=" ">
                    <Tooltip title="Selecione uma conta">
                      <Button
                        className="buttonPendente"
                        icon={<PhosphorIcon.HourglassMedium size={16} className="buttonPendente" weight="light" />}
                        onClick={pendente}
                        disabled={selectedRowKeys.rows.length === 0}
                      >
                        PENDENTE
                      </Button>
                    </Tooltip>
                  </Form.Item>
                </>
              )}
            </Flex>
          </Col>
        </Row>
      </Form>
      <Row gutter={12}>
        <Col span={24}>
          <TableComponent
            data={auditoriaState.list}
            columns={columns}
            loading={auditoriaState.loading}
            selectionType={"checkbox"}
            rowSelection={selecionarLinha}
            tableProps={{
              className: "tabelacontaAuditoria",
              onRow: (record: AuditoriaContaFinanceiraVWModel) => {
                return {
                  onClick: () => {
                    goVisualizar(record);
                  },
                };
              },
            }}
          />
        </Col>
      </Row>
      <Modal title={editar ? "EDITAR OBSERVAÇÃO" : "OBSERVAÇÃO"} centered width={750} open={auditoriaState.modalObservacao} onCancel={closeModalObservacao} footer={null} destroyOnHidden>
        <ObservacaoAuditoriaModal />
      </Modal>
      <Modal title={"HISTÓRICO DE AUDITORIA DA CONTA FINANCEIRA"} centered width={850} open={auditoriaState.modalHistorico} onCancel={closeModalHistorico} footer={null} destroyOnHidden>
        <HistoricoAuditoriaModal />
      </Modal>
      <Drawer width={260} title="VISUALIZAR ANEXOS" placement="right" onClose={closeVisualizarArquivos} open={openVisualizarArquivos} getContainer={false}>
        <VisualizarArquivosAuditoria />
      </Drawer>
    </Flex>
  );
};

export default GeralPage;
